<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.44971 4.58789L2.72929 4.59065L1.44971 6.39663H2.68392"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.2998 3.58796L2.14889 1.6001L2.99797 3.58796M1.6498 2.92511H2.6498"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-miterlimit="4.13936"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.771 3.12158L5.6457 2.00001L4.50005 3.12158"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.646 2.2L5.646 6"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
